import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminApi } from "../lib/adminApi";

export default function AdminLogin() {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await adminApi.post("/login", { password });
      nav("/admin");
    } catch (err) {
      setError(err?.response?.data?.detail || "Přihlášení selhalo.");
    } finally { setLoading(false); }
  };

  return (
    <main className="min-h-screen bg-cream flex items-center justify-center px-5 py-24">
      <form onSubmit={submit} className="bg-ivory border border-charcoal/10 p-8 md:p-10 w-full max-w-md" data-testid="admin-login-form">
        <div className="text-[11px] tracking-[.28em] uppercase text-burgundy mb-3">Administrace</div>
        <h1 className="font-serif text-3xl mb-6">Přihlášení</h1>
        <label className="block">
          <span className="block text-[11px] tracking-[.2em] uppercase text-charcoal/60 mb-1.5">Heslo</span>
          <input
            type="password"
            required
            autoFocus
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="admin-password"
            className="w-full bg-ivory border border-charcoal/25 px-3 py-2.5 text-sm"
          />
        </label>
        {error && <div className="mt-3 text-sm text-red-700" role="alert" data-testid="admin-login-error">{error}</div>}
        <button type="submit" disabled={loading} data-testid="admin-login-submit"
          className="mt-6 w-full bg-burgundy hover:bg-burgundy-hover text-ivory py-3 tracking-wide disabled:opacity-60">
          {loading ? "Přihlašuji…" : "Přihlásit se"}
        </button>
        <p className="mt-5 text-xs text-charcoal/55 leading-relaxed">
          Přihlášení je určeno pouze provozovateli.
        </p>
      </form>
    </main>
  );
}
